import RestClient from '../../../../../api/axiosInterceptor';
import {
  patientLoginActions,
  patientLogoutActions
} from '../../../../actions/user/patient/auth/login';

/**
 * Helper function to create asynchronous actions for Redux.
 * @param {string} actionType - The action type to dispatch.
 * @param {function} apiCall - The API call function to make the request.
 */
const createAsyncAction = (actionType, apiCall) => async (dispatch) => {
  try {
    // Dispatch the request action before making the API call
    dispatch({ type: actionType.REQUEST });

    // Make the API call and wait for the response
    const response = await apiCall();

    // Dispatch success action with response data
    dispatch({
      type: actionType.SUCCESS,
      payload: response.data
    });
    return response; // Return the response to the UI for further handling
  } catch (error) {
    // Dispatch failure action if an error occurs
    dispatch({
      type: actionType.FAILURE,
      error: error.response ? error.response.data : error.message
    });
    throw error; // Propagate the error for handling in the UI
  }
};

const encodeCredentials = (email, password) => {
  try {
    return btoa(`${email}:${password}`);
  } catch (error) {
    console.error('Error encoding credentials:', error);
    throw new Error('Invalid credentials format');
  }
};

// export const loginPatient = (formData) =>
//   createAsyncAction(patientLoginActions.LOGIN_PATIENT, () =>
//     RestClient.post('/patient/', formData, {
//       headers: { 'Content-Type': 'application/json' }
//     }).then((response) => {
//       if (!response.data) {
//         throw new Error('Invalid response from server');
//       }

//       const credentials = encodeCredentials(formData.email, formData.password);

//       // Store credentials and authentication flag in localStorage
//       localStorage.setItem('patientCredentials', credentials);
//       localStorage.setItem('isAuthenticated', 'true');

//       return {
//         ...response,
//         data: {
//           patient: response.data,
//           credentials
//         }
//       };
//     })
//   );
export const loginPatient = (formData) =>
  createAsyncAction(patientLoginActions.LOGIN_PATIENT, () =>
    RestClient.post('/patient/', formData, {
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCsrfToken() // Add CSRF protection
      }
    }).then((response) => {
      if (!response.data) {
        throw new Error('Invalid response from server');
      }

      const credentials = encodeCredentials(formData.email, formData.password);

      // Set token expiry - 6 hours from now
      const expiryTime = new Date();
      expiryTime.setHours(expiryTime.getHours() + 6);

      // Store credentials and authentication flag in localStorage
      localStorage.setItem('patientCredentials', credentials);
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('tokenExpiry', expiryTime.toISOString());

      return {
        ...response,
        data: {
          patient: response.data,
          credentials
        }
      };
    })
  );

// Helper function to get CSRF token from cookies
const getCsrfToken = () => {
  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith('csrftoken='))
    ?.split('=')[1];

  return cookieValue || '';
};

// Action creator for patient logout
export const logoutPatient = () =>
  createAsyncAction(patientLogoutActions.LOGOUT_PATIENT, () =>
    RestClient.post('/patient/logout')
  );
